import {
  daysIn,
  MAX_DAY_BUCKETS,
  seriesUnitOfRange,
  type DayRange,
  type SeriesUnit,
} from '../report-period.ts';
import type { ProductRanking } from './performance.ts';

export const GAINS_GROUPS = ['auto', 'day', 'week', 'month'] as const;
export type GainsGroup = (typeof GAINS_GROUPS)[number];

export const TOP_RANKINGS = ['units', 'sales'] as const satisfies readonly ProductRanking[];

export const groupsAllowedFor = (range: DayRange): readonly GainsGroup[] =>
  daysIn(range) <= MAX_DAY_BUCKETS ? GAINS_GROUPS : GAINS_GROUPS.filter((group) => group !== 'day');

export const seriesUnitOf = (group: GainsGroup, range: DayRange): SeriesUnit =>
  group === 'auto' || !groupsAllowedFor(range).includes(group) ? seriesUnitOfRange(range) : group;
